export const PASSWORD_REQUIREMENTS = {
  hasLowercase: {
    test: (password: string) => /[a-z]/.test(password),
    label: "one lowercase character",
  },
  hasUppercase: {
    test: (password: string) => /[A-Z]/.test(password),
    label: "one uppercase character",
  },
  hasSpecialChar: {
    test: (password: string) => /[^A-Za-z0-9]/.test(password),
    label: "one special character",
  },
  hasMinLength: {
    test: (password: string) => password.length >= 8,
    label: "minimum 8 characters",
  },
  hasNumber: {
    test: (password: string) => /\d/.test(password),
    label: "one number",
  },
};
